module.exports = __webpack_public_path__ + "static/media/east tower final shot 004.857442d5.webp";